

const inkActivity = {
  bindings: {
    conversationId: '<',
    appointmentId: '<',
    activityTitle: '<',
    projectId: '<',
    hasMessages: '<',
    hasAppointmentActivity: '<',
    hasProjectActivity: '<'
  },
  controller: 'ActivityController',
  template: require('./activity.template.html')
};

angular
  .module('inkfinder')
  .component('inkActivity', inkActivity);



// WEBPACK FOOTER //
// ./components/activity/activity.component.js